import {get} from "lodash"

export default function getCodeFromError(err: any): string {
  // if there is a config property, it was probably an axios request
  const fallback = err.config ? "Network Error" : ""

  return (
    attemptToGetCode(err) || fallback // we have no idea
  )
}

/**
 * @description: low level functionality to find a potential error code,
 * you should probably use `getCodeFromError()` instead
 */
export function attemptToGetCode(err: any): string | undefined {
  return (
    err.code || // simple assign
    err.errorCode || // graph response
    get(err, "response.data.code") || // REST API response
    undefined
  )
}
